export default "__VITE_ASSET__F7z1AO_r__"